import { useState } from 'react'
import { Share2, Check } from 'lucide-react'
import { clsx } from 'clsx'

/** Copy the current full URL (including query string) to the clipboard so the
 * user can share their exact filtered view. Pages that wire their filters to
 * useSearchParams get share-anywhere behaviour for free. */
export default function ShareViewButton({ className }: { className?: string }) {
  const [copied, setCopied] = useState(false)

  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href)
      setCopied(true)
      setTimeout(() => setCopied(false), 1600)
    } catch {
      // Clipboard API blocked — fall back to selecting via prompt
      window.prompt('Copy this URL:', window.location.href)
    }
  }

  return (
    <button
      type="button"
      onClick={onClick}
      title="Copy a shareable link to this filtered view"
      className={clsx(
        'inline-flex items-center gap-1.5 py-2 px-2.5 rounded-md border text-xs',
        copied
          ? 'border-emerald/50 bg-emerald/10 text-emerald'
          : 'border-border bg-surface-card hover:bg-surface-hover text-text-secondary',
        className,
      )}
      aria-label={copied ? 'Link copied' : 'Copy shareable link'}
    >
      {copied ? <Check size={14} /> : <Share2 size={14} />}
      {copied ? 'Copied' : 'Share view'}
    </button>
  )
}
